import { setCookie } from '@cian/utils/lib/browser/cookie';

import { FEEDBACK_COOKIE_NAME } from '../../constants';
import { sendFeedback } from '../../services/sendFeedback';
import { IFeedbackDataRequest, IFeedbackDataResponseSchema } from '../../types';
import { IThunkActionCreator } from '../../types/store';

export interface IFeedbackBannerClosed {
  type: 'FeedbackBannerClosed';
}

export function sendFeedbackAction(
  parameters: IFeedbackDataRequest,
): IThunkActionCreator<Promise<IFeedbackDataResponseSchema>> {
  return async (dispatch, getState, context) => {
    return sendFeedback(context, parameters, context.subdomain);
  };
}

export function feedbackBannerClosed(): IFeedbackBannerClosed {
  setCookie(FEEDBACK_COOKIE_NAME, '1', {
    domain: '.cian.ru',
    secure: false,
  });

  return {
    type: 'FeedbackBannerClosed',
  };
}

export type Action = IFeedbackBannerClosed;
